import {ErrorMessage, Field, Form, Formik} from "formik";
import postData from "../services/postData";
import Modal from "./Modal";
import {useState} from "react";
import {ScrollToFieldError} from "./formik/ScrollToFieldError";
import SkodaSecondDataInfo from "./SkodaSecondDataInfo";
import {formSchema} from "../schema/formSchema";
import SkodaDataInfo from "./SkodaDataInfo";
import SkodaDataMoreInfo from "./SkodaDataMoreInfo";

export default function ServiceForm({setLoadingSpinnerOpen}) {

    const [successModal, setSuccessModal] = useState(false);
    const [failureModal, setFailureModal] = useState(false);
    const [formIsSubmitting, setFormIsSubmitting] = useState(false);

    const dataLayerPush = (orderId) => {
        try {
            window.dataLayer.push({
                'event': 'formularze',
                'wypelniony-formularz': 'serwis-zamowiono',
                'orderid': orderId
            });
            console.log('dataLayer.push ok:', orderId);
        } catch (err) {
            console.error('dataLayer.push error:', err);
        }
    };

    const syneriseSendFormData = (orderId, values) => {
        if (!('SR' in window)) {
            console.error('SR undefined');
            return;
        }

        const formType = 'otm,sms,superb,combi,03,2024';

        const snrData = {
            orderID: orderId,
            firstname: values.firstName, //imie
            phone: values.phone, //telefon
            email: values.email, //email
            date: values.date, //dzień
            hour: values.hour, //dzień
            newsletterAgreement: values.newsletterAgreement && 'enabled',
            newsletter_info: values.newsletter_info,
            statute: values.statute,
        };
        try {
            window.SR.event.sendFormData(formType, snrData)
                .then((res) => {
                    console.log(snrData);
                    console.log(formType);
                    console.log(res);
                })
                .catch((err) => {
                    console.log(formType);
                    console.error(err);
                });
        } catch (err) {
            console.error('SR error', err);
        }
    };

    return (
        <Formik
            initialValues={{
                firstName: '',
                phone: '',
                email: '',
                date: '',
                hour: '',
                newsletterAgreement: false,
                newsletter_info: false,
                statute: false,
            }}
            validationSchema={formSchema}
            onSubmit={(values, actions) => {
                actions.setSubmitting(false);
                setFormIsSubmitting(true);
                // console.log(values);
                // setLoadingSpinnerOpen(true);

                postData(values)
                    .then((data) => {
                        if (data && data.status === 'ok') {

                            dataLayerPush(data.orderId);
                            syneriseSendFormData(data.orderId, values);
                            actions.resetForm();
                            setSuccessModal(true);
                        } else {
                            setFailureModal(true);
                        }
                    })
                    .catch((error) => {
                        setFailureModal(true);
                    })
                    .finally(() => {
                        setFormIsSubmitting(false);
                        // setLoadingSpinnerOpen(false);
                        window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: "smooth"
                        });
                    });
            }}
        >
            {(formikProps) => (
                <>
                    {/*{successModal && (*/}
                    {/*    window.location.href = "https://twoja.skoda.pl/brandportal/newsletter/brandportal/dziekujemy"*/}
                    {/*)}*/}
                    <Modal open={successModal} setOpen={setSuccessModal}>
                        <b>Dziękujemy za zapis</b>
                    </Modal>

                    <Modal open={failureModal} setOpen={setFailureModal}>
                        Wystąpił błąd!<br/>
                        Prosimy spróbować później.
                    </Modal>

                    <Form className="form-container form-container js-subscribe-form" method={`post`}>
                        <ScrollToFieldError/>


                        <div className="form-row">
                            <div className="form-copy">
                                <b>Odkryj nową Škodę Superb Combi</b>
                                <br/><br/>
                                Nie przegap prezentacji nowej Škody Superb Combi w Salonie Online. Dołącz do nas i zobacz jak ekscytujące zmiany zaszły w tym wyjątkowym modelu. Wybierz odpowiedni dla Ciebie termin, zapisz się a my wyślemy Ci przypomnienie o spotkaniu SMS-em.                                 <br/><br/>
                            </div>
                        </div>

                            <div className="form-row">
                                <label className="form-label" htmlFor="firstName">Imię</label>
                                <Field id="firstName" name="firstName" type="text" className="form-input" maxLength={50}></Field>
                                <ErrorMessage name="firstName">{msg => <div className="form-error">{msg}</div>}</ErrorMessage>
                            </div>

                        <div className="form-row form-row--inline js-form-item-firstname">
                            <label className="form-label" htmlFor="phone">Nr telefonu*</label>
                            <Field id="phone" name="phone" type="tel" className="form-input" maxLength={9}></Field>
                            <ErrorMessage name="phone">{msg => <div className="form-error">{msg}</div>}</ErrorMessage>
                        </div>

                        <div className="form-row">
                            <label className="form-label" htmlFor="email">Email</label>
                            <Field id="email" name="email" type="email" className="form-input" maxLength={255}></Field>
                            <ErrorMessage name="email">{msg => <div className="form-error">{msg}</div>}</ErrorMessage>
                        </div>
                        {/*<div style={{paddingBottom: "10px"}}>&nbsp;</div>*/}
                        <br/>
                        <div className="form-row">
                            <label className="form-label" htmlFor="date">
                                Wybierz dzień*
                            </label>
                            <Field
                                as="select"
                                id="date"
                                name="date"
                                className="form-input"
                            >
                                <option value=""></option>
                                <option value="29.03">29.03</option>
                                <option value="30.03">30.03</option>
                                <option value="02.04">02.04</option>
                                <option value="03.04">03.04</option>
                            </Field>
                            <ErrorMessage name="date">
                                {msg => <div className="form-error">{msg}</div>}
                            </ErrorMessage>
                        </div>

                        <div className="form-row">
                            <label className="form-label" htmlFor="date">
                                Wybierz godzinę*
                            </label>
                            <Field
                                as="select"
                                id="hour"
                                name="hour"
                                className="form-input"
                            >
                                <option value=""></option>
                                <option value="11:00">11:00</option>
                                <option value="13:00">13:00</option>
                                <option value="15:00">15:00</option>
                                <option value="17:00">17:00</option>
                                <option value="19:00">19:00</option>
                            </Field>
                            <ErrorMessage name="hour">
                                {msg => <div className="form-error">{msg}</div>}
                            </ErrorMessage>
                        </div>

                        <div className="form-info-container">
                            <div className="form-info">
                                <p>Pozostawienie przez Ciebie danych i wysłanie formularza oznacza Twoją zgodę dla Volkswagen Group Polska sp. z o.o. na skontaktowanie się z Tobą w celu przesłania przypomnienia o prezentacji marki Škoda na podany nr telefonu. Podanie Twoich danych jest dobrowolne, lecz niezbędne do obsługi Twojego zapytania.                </p>
                            </div>
                        </div>

                        <div className="form-info">
                            <p>
                                <b>Odkryj świat marki Škoda! Zapisz się do&nbsp;newslettera i&nbsp;bądź na&nbsp;bieżąco</b>
                            </p>
                        </div>
                        <div className="form-row">
                            <div className="form-checkbox">
                                <Field className="form-check-input" id="newsletterAgreement" name="newsletterAgreement" type="checkbox"></Field>
                                <label htmlFor="newsletterAgreement" className="form-check-label">
                                    Chcę otrzymywać Newsletter od Volkswagen Group Polska Sp. z o.o. z wykorzystaniem adresu e-mail oraz pozostałych podanych przeze mnie Danych.                               </label>
                            </div>
                            <ErrorMessage name="newsletterAgreement">{msg => <div className="form-error">{msg}</div>}</ErrorMessage>
                        </div>
                        <div className="form-row">
                            <div className="form-checkbox">
                                <Field className="form-check-input" id="newsletter_info" name="newsletter_info" type="checkbox"></Field>
                                <label htmlFor="newsletter_info" className="form-check-label">
                                    W ramach Newslettera zgadzam się na otrzymywanie od Volkswagen Group Polska Sp. z o.o. w/w informacji mogących stanowić informacje handlowe i marketingowe.                           </label>
                            </div>
                            <ErrorMessage name="newsletter_info">{msg => <div className="form-error">{msg}</div>}</ErrorMessage>
                        </div>
                        <div className="form-row">
                            <div className="form-checkbox">
                                <Field className="form-check-input" id="statute" name="statute" type="checkbox"></Field>
                                <label htmlFor="statute" className="form-check-label">
                                    Akceptuję <a
                                    href="https://twoja.skoda.pl/brandportal/newsletter/rules/0afc6cb8156bd43640a6a5f47d5f655f4c45c2b1.pdf"
                                    target="_blank">regulamin</a>
                                </label>
                            </div>
                            <ErrorMessage name="statute">{msg => <div className="form-error">{msg}</div>}</ErrorMessage>
                        </div>
                        <SkodaSecondDataInfo/>
                        <SkodaDataMoreInfo/>
                        <br/>
                        <div className="form-row form-row--buttons">
                            <button type="submit" className="button button--primary" disabled={formIsSubmitting}>Zapisz</button>
                        </div>
                    </Form>
                </>
            )}
        </Formik>
    );
}
